import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { SET_IS_CURATION_ENABLED_DIET_MUTATION } from '../graphql/mutations'
import { SET_IS_CURATION_ENABLED_DIET } from '../redux/action-types'

const useSetIsCurationEnabledDietMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.diets.dietsAndDietCategories,
  )

  const mutate = useCallback(
    async (id, isCurationEnabled, type) => {
      await apolloService.mutate(
        SET_IS_CURATION_ENABLED_DIET_MUTATION,
        {
          id,
          isCurationEnabled,
          type,
        },
        dispatch,
        SET_IS_CURATION_ENABLED_DIET,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useSetIsCurationEnabledDietMutation
